import React from 'react';
import DemoFrame from './DemoFrame';
import useDemoPlayer, { typingDuration, useTypedText } from './useDemoPlayer';
import { DEMO_IMAGE } from './demoFixtures';

const I = DEMO_IMAGE;

// 0 요청 입력 → 1 그리는 중 → 2 이미지 → 3(완성) 저장·수정하기
const STEPS = [typingDuration(I.prompt, 2, 30), 1300, 900];

const ImageResultDemo = ({ surface = 'home', title = 'AI 이미지', autoStart = false }) => {
  const player = useDemoPlayer({ steps: STEPS, surface, feature: 'image', autoStart });
  const { phase, done, paused } = player;
  const prompt = useTypedText(I.prompt, { active: phase === 0, complete: phase > 0, paused, charsPerTick: 2, tickMs: 30 });

  return (
    <DemoFrame title={title} player={player}>
      <div className="wqdemo-chat">
        <div className="wqdemo-bubble-user">
          {prompt}
          {phase === 0 && <span className="wqdemo-cursor" style={{ background: '#ffffff' }} />}
        </div>
        {phase >= 1 && (
          <div className="wqdemo-image-card wqdemo-in">
            {phase === 1 ? (
              <div className="wqdemo-image-wait">
                <div className="wqdemo-skeleton" style={{ width: '100%', height: '100%' }} />
                <span>그리는 중…</span>
              </div>
            ) : (
              <img src={I.src} alt={I.alt} className="wqdemo-image" loading="lazy" />
            )}
            {done && (
              <div className="wqdemo-image-toolbar wqdemo-in">
                <span className="wqdemo-btn is-soft">저장</span>
                <span className="wqdemo-btn is-soft">수정하기</span>
              </div>
            )}
          </div>
        )}
      </div>
    </DemoFrame>
  );
};

export default ImageResultDemo;
